import React from 'react';
import style from './WeeklyHeader.module.css';
import imgPrev from '../../images/common/i_arrow_sm_left.svg';
import imgNext from '../../images/common/i_arrow_sm_right.svg';
import SparkleIcon from '../../components/home/SparkleIcon';

const WeeklyHeader = ({ weekNum, dateRange, message, mascotImg, onPrev, onNext, hasPrev, hasNext, loading = false }) => {
    return (
        <div className={style.wrap}>
            <div className={style.weekNav}>
                <strong className={style.weekLabel}>건강 리포트 
                    {loading ? <span className={`${style.skBar} ${style.skInline}`} style={{ width: 52, height: 17, borderRadius: 6 }} /> 
                    : weekNum ? <b>{weekNum}주차</b> : null}
                </strong>
                <div className={style.dateControl}>
                    <button className={style.arrow} onClick={onPrev} disabled={!hasPrev}>
                        <img src={imgPrev} alt="이전 이동" />
                    </button>
                    <span className={style.dateRange}>{dateRange}</span>
                    <button className={style.arrow} onClick={onNext} disabled={!hasNext}>
                        <img src={imgNext} alt="다음 이동" />
                    </button>
                </div>
            </div>

            {loading ? (
                <div className={style.statusCard} aria-hidden="true">
                    <div className={style.cardHeader}>
                        <div className={style.titleBox}>
                            <span className={style.skBar} style={{ width: 76, height: 15 }} />
                            <span className={style.skBar} style={{ width: '78%', height: 19, marginTop: 10 }} />
                        </div>
                        <div className={style.cardMasco}>
                            <span className={style.skMascot} />
                        </div>
                    </div>
                    <div className={style.cardBody}>
                        <span className={style.skBar} style={{ width: '94%', height: 13, marginTop: 9 }} />
                        <span className={style.skBar} style={{ width: '60%', height: 13, marginTop: 9 }} />
                    </div>
                </div>
            ) : message && (
                /* AI 문구가 아직 없으면 빈 카드가 뜨지 않게 통째로 숨긴다 */
                <div className={style.statusCard}>
                    <div className={style.cardHeader}>
                        <div className={style.titleBox}>
                            <p><SparkleIcon size={22} /> AI 분석</p>
                            <strong className={style.statusTitle}>{message.title}</strong>
                        </div>
                        <div className={style.cardMasco}>
                            {mascotImg && <img className={style.mascot} src={mascotImg} alt="식단 마스코트" draggable={false} />}
                        </div>
                    </div>
                    <div className={style.cardBody}>
                        <p className={style.statusDesc}>{message.desc}</p>
                    </div>

                </div>
            )}
        </div>
    );
};

export default WeeklyHeader;